
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Release Notes</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div>
        <markdown *ngIf="releaseNotesUrl" [src]="releaseNotesUrl"></markdown>
      </div>
    </div>
  </div>
</div>